import { Suspense } from "react"
import { useTranslation } from "react-i18next"
import { PotentiallyUnsafeInnerHtml } from "@/components/potentially-unsafe-inner-html"
import { Button } from "@/components/ui/button"
import { MedicationNewsTooltip } from "@/modules/patients/detail/medication/ch/medication-news-tooltip"
import { PreparationDetailArticle } from "@/modules/patients/detail/medication/ch/schema/medication-schema"
import { MedicationDetail } from "@/modules/patients/detail/medication/components/ch-medication-search"
import { MEDICATION_MODES, MedicationMode } from "@/modules/patients/detail/medication/types/medication-mode"
interface PreparationSelectionProps {
  medication: MedicationDetail
  handleSearchMedicationText: () => void
  chMedicationMode: MedicationMode
  atcCode?: string | null
}

export const formatPharmaInformationText = (article?: PreparationDetailArticle) => {
  if (!article) return ""

  const currencyUnit = article.publicPrice ? "CHF" : null
  return [article.description, article.publicPrice, currencyUnit].filter(Boolean).join(" ")
}

export const PreparationSelection = ({
  medication,
  handleSearchMedicationText,
  chMedicationMode,
}: PreparationSelectionProps) => {
  const { t } = useTranslation()
  const { itemId, hasNews, productUrl, name } = medication

  return (
    <div className="border-border mb-8 rounded-lg border px-4 pt-2 pb-4" data-testid="preparation-selection">
      <div className="grid items-center gap-2">
        <div className="flex flex-row justify-between">
          <PotentiallyUnsafeInnerHtml
            className="text-on-surface inline text-base leading-6 font-medium"
            value={name ?? ""}
          />
          {itemId && hasNews && (
            <Suspense>
              <MedicationNewsTooltip medicationItemId={itemId} />
            </Suspense>
          )}
        </div>
        <div className="grid gap-4">
          {productUrl && (
            <a
              className="text-primary w-fit text-sm underline"
              href={productUrl}
              target="_blank"
              rel="noopener noreferrer">
              {t("patient.medication.compendium")}
            </a>
          )}
          <div className="flex w-full items-center justify-between">
            {chMedicationMode === MEDICATION_MODES.CREATION && (
              <Button variant="secondary" className="w-fit self-end" onClick={handleSearchMedicationText}>
                {t("patient.medication.searchWithAtcCode")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
